import { EventEmitter } from 'eventemitter3'

type AuthEvent = {
  logout: VoidFunction
}

export const authEventEmitter = new EventEmitter<AuthEvent>()
